
import { get, post, put, remove } from "@/utils/request";


// 获取字段域列表
export const getDomainFieldList = params => {
    return get<any>(`/cmp-doc/systemManager/field/list`, params, {}, 'document');
};

// 新增字段域
export const addFieldDomain = (data) => {
    return post<any>(`/cmp-doc/systemManager/field/add`, data, {}, 'document');
};

// 批量新增字段域
export const batchAddFieldDomain = (data) => {
    return post<any>(`/cmp-doc/systemManager/field/batchAdd`, data, {}, 'document');
};

// 更新字段域
export const updateFieldDomain = (id, data) => {
    return put<any>(`/cmp-doc/systemManager/field/update/${id}`, data, {}, 'document');
};

// 批量更新字段域
export const batchUpdateFieldDomain = (data) => {
    return put<any>(`/cmp-doc/systemManager/field/batchUpdate`, data, {}, 'document');
};

// 删除字段域
export const deleteFieldDomain = (id) => {
    return remove<any>(`/cmp-doc/systemManager/field/delete/${id}`, {}, {}, 'document');
};

// 删除字段域
export const cascadeDeleteFieldDomain = (id) => {
    return remove<any>(`/cmp-doc/systemManager/field/cascadeDelete/${id}`, {}, {}, 'document');
};

// 移动字段域
export const moveFieldDomain = (id, groupId) => {
    return put<any>(`/cmp-doc/systemManager/field/move/${id}?groupId=${groupId}`, {}, {}, 'document');
};

// 上移字段域
export const moveUpFieldDomain = (id) => {
    return put<any>(`/cmp-doc/systemManager/field/moveUp/${id}`, {}, {}, 'document');
};

// 下移字段域
export const moveDownFieldDomain = (id) => {
    return put<any>(`/cmp-doc/systemManager/field/moveDown/${id}`, {}, {}, 'document');
};

// 新增分组节点
export const addGroupNode = (data) => {
    return post<any>(`/cmp-doc/systemManager/field/addGroupNode`, data, {}, 'document');
};

// 删除分组节点
export const deleteGroupNode = (groupId) => {
    return remove<any>(`/cmp-doc/systemManager/field/deleteGroupNode/${groupId}`, {}, {}, 'document');
};

// 更新分组节点
export const updateGroupNode = (groupId, data) => {
    return put<any>(`/cmp-doc/systemManager/field/updateGroupNode/${groupId}`, data, {}, 'document');
};


// 上移组
export const moveUpGroupNode = (groupId) => {
    return put<any>(`/cmp-doc/systemManager/field/group/moveUp/${groupId}`, {}, {}, 'document');
};

// 下移组
export const moveDownGroupNode = (groupId) => {
    return put<any>(`/cmp-doc/systemManager/field/group/moveDown/${groupId}`, {}, {}, 'document');
};



